export default function AddDatasetIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9435 40V0H25.0565V40H14.9435ZM0 25.0565V14.9435H40V25.0565H0Z"
        fill="currentColor"
      />
    </svg>
  );
}
